import { z } from 'zod/v3';
import { SampleDataSubjectFormDataSchema } from './SampleFormDataSchema';
import { createPaginationSchema } from '../../common/utils/schema/paginationSchema';

export const SamplePageSchema = createPaginationSchema(
  SampleDataSubjectFormDataSchema,
);

export type SamplePageType = z.infer<typeof SamplePageSchema>;
